import React from "react";
import "./styles/HistoryContent.scss";
import { useTranslation } from "react-i18next";
const HistoryContent = () => {
  const { t } = useTranslation();
  const imgPath = ["/imgs/aboutus_history_content_01.png", "/imgs/aboutus_history_content_02.png", "/imgs/aboutus_history_content_03.png", "/imgs/aboutus_history_content_04.png", "/imgs/aboutus_history_content_05.png"];
  const outline = t("aboutUs.history.content.outline.data", { returnObjects: true }) as { name: string; des: string }[];
  const certification = t("aboutUs.history.content.certification.data", { returnObjects: true }) as string[];
  const history = t("aboutUs.history.content.history.content", { returnObjects: true }) as { imgPath: string; list: string[] }[];

  return (
    <>
      <div id="history_content_wrap">
        <div className="left">
          <div className="img_wrap">
            {imgPath.map((path, index) => {
              return (
                <div className="img_box" key={`${path}_${index}`}>
                  <img src={path} alt="office" />
                </div>
              );
            })}
          </div>
        </div>
        <div className="right">
          <div className="outline_wrap">
            <div className="title_wrap">{t("aboutUs.history.content.outline.title")}</div>
            <div className="contents">
              {outline.map((data, index) => {
                return (
                  <div className="content" key={`${data.name}_${index}`}>
                    <div className="name_wrap">{data.name}</div>
                    <div className="des_wrap">{data.des}</div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="certification_wrap">
            <div className="title_wrap">{t("aboutUs.history.content.certification.title")}</div>
            <ul className="contents">
              {certification.map((text, index) => {
                return <li key={`${text}_${index}`}>{text}</li>;
              })}
            </ul>
          </div>
          <div className="history_wrap">
            <div className="title_wrap">{t("aboutUs.history.content.history.title")}</div>
            <div className="contents">
              {history.map((content, index) => {
                return (
                  <div className="content" key={`histoy_list_aaa_${index}`}>
                    <div className="img_box">
                      <img src={content.imgPath} alt="year" />
                    </div>
                    <ul>
                      {content.list.map((data, index2) => {
                        return <li key={`${data}_${index2}_${index}`}>{data}</li>;
                      })}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HistoryContent;
